// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //serverUrl: 'http://127.0.0.1:4300/',
  serverUrl: 'https://1f18dc0bkc.execute-api.us-east-1.amazonaws.com/dev/',
  serverUrl1: 'https://ecomflows3.zaravya.com/',
  API_AUTH_KEY: 'nuigh&YT7Q3RBUyt63#bIGgvadi',
  // API_AUTH_KEY: 'nuigh&YT7Q3RBUyt63$W3acfedb#bIGgvadi',

  ccavenue_accesscode: 'AVYZ02GE67AH84ZYHA',
  ccavenue_merchant_id: 195866,
  ccavenue_redirect_url: 'http://127.0.0.1:4200/ccavenueResponseHandler',
  ccavenue_payment_url: 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction',
  APP: 'ChefDesk',
  firebase: {
    apiKey: "AIzaSyB0GsrHdDDE4LVlr7sIKsdorMaor4s5QN8",
    authDomain: "chefdesk-analytics.firebaseapp.com",
    databaseURL: "https://chefdesk-analytics.firebaseio.com",
    projectId: "chefdesk-analytics",
    storageBucket: "chefdesk-analytics.firebasestorage.app",
    messagingSenderId: "852171967303",
    appId: "1:852171967303:web:5802f132da34415e429a62",
    measurementId: "G-4KXXNZLERS"
  },
  year: '2021',

  // GET_RESTAURANT_DETAILS: 'https://958y79v5si.execute-api.us-east-1.amazonaws.com/Stage1',
  GET_RESTAURANT_DETAILS: 'https://ecomflows3.zaravya.com/getRestaurantDetails',

  // imageUrls: 'https://app.eposfx.com/epos/interface/loadImage/',
  // imageUrls: 'https://masters-api.chefdesk.in/epos-customer/api/v1/download/',
  // imageUrls: 'https://s3.amazonaws.com/posdirect/pictures/',
  imageUrls: 'https://posdirect2.s3.us-east-2.amazonaws.com/pictures/',



  //razorpaykey: 'rzp_test_LhOgswSuRLeh2M',

  razorpaykey: 'rzp_live_qq26Px4AOKUB50',

  UserPoolId: 'us-east-1_H90O9MYLe',
  ClientId: '1491f4voj5keq02dvoo4lunnt0',

  mode: 'LIVE',

  Email: "appsupport@zaravya.com"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
